import dayjs from "dayjs";

export const normalizeComparisonValue = (value: any): any => {
  if (value instanceof Date) {
    return value.toISOString().slice(0, 10);
  }

  if (Array.isArray(value)) {
    return value.map(normalizeComparisonValue);
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, nestedValue]) => [
        key,
        normalizeComparisonValue(nestedValue),
      ]),
    );
  }

  return value ?? null;
};

export const comparisonValuesDiffer = (a: any, b: any) =>
  JSON.stringify(normalizeComparisonValue(a)) !== JSON.stringify(normalizeComparisonValue(b));

export const hasComparisonValue = (value: any) =>
  value !== undefined && value !== null && value !== "";

export const formatComparisonDate = (value: any, format: "date" | "month" = "date") => {
  if (!value) {
    return "-";
  }

  const dateValue = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(dateValue.getTime())) {
    return String(value);
  }

  return dayjs(dateValue).format(format === "month" ? "MM/YYYY" : "DD/MM/YYYY");
};

export const toComparisonDateValue = (value: any) => (value ? new Date(value) : undefined);
